import React from 'react';

import { Svg, Path, SvgProps } from 'react-native-svg';

import { colors } from '@/constants/colors';

const StabilityBallIcon: React.FC<SvgProps> = (props) => {
  const {
    width = '100%',
    height = '100%',
    color = colors.white.primary,
    ...rest
  } = props;

  return (
    <Svg
      enable-background={'new 0 0 34 34'}
      viewBox={'0 0 34 34'}
      width={width}
      height={height}
      {...rest}
    >
      <Path
        fill={color}
        d={
          'm1.65 21.66c-.58-.06-.92-.33-1.04-.91-.19-.88-.41-1.76-.61-2.64v-4.15h0c.17-.75.33-1.5.5-2.25.1-.41.25-.67.67-.23 2.15 2.24 4.67 2.1 7.18.87 2.82-1.38 4.65-3.65 5.23-6.82.3-1.67-.09-3.17-1.24-4.43-.43-.47-.31-.64.26-.75 2.43-.49 4.85-.47 7.27.13.35.09.64.2.76.6 1.56 5.21 1.36 10.24-1.96 14.75-3.52 4.77-8.32 6.85-14.25 6.21-.92-.1-1.84-.26-2.76-.36zm28.06-13.89c-.22-.37-.4-.79-.92-1.13.16 1.75.32 3.36.24 4.98-.32 6.89-3.54 12.02-9.52 15.38-3.88 2.18-8.04 2.56-12.36 1.69-.26-.05-.55-.18-.82.08.1.11.16.2.24.26.21.16.43.31.66.45 2.03 1.34 4.28 2.1 6.66 2.51h4.15c.15-.04.3-.09.46-.12 11.25-1.89 17.02-14.31 11.21-24.11zm-15.8 20.22c8.48-1.62 14.25-8.59 14.23-17.4.07-.85-.18-1.88-.17-2.91 0-2.29-1.13-3.82-3.02-4.94-.8-.47-1.6-.95-2.44-1.34-.21-.1-.46-.29-.67-.15-.25.17-.04.44-.02.66.01.13.06.26.09.39.59 2.62.77 5.24.24 7.9-1.43 7.22-7.9 12.67-15.26 12.85-1.6.04-3.18-.18-4.76-.38-.2-.02-.45-.18-.59.05-.12.2.05.41.15.59.34.6.69 1.2 1.05 1.79.89 1.47 2.04 2.41 3.9 2.6 2.43.24 4.82.75 7.28.29zm-9.04-15.73c3.6 0 7.23-3.24 7.79-6.79.27-1.69-.19-3.08-1.48-4.22-.3-.26-.57-.36-.93-.21-4.1 1.64-7.11 4.46-8.95 8.5-.11.25-.2.49.02.74.99 1.13 2.08 2.07 3.56 1.98z'
        }
      />
    </Svg>
  );
};

export default StabilityBallIcon;
